import { render, staticRenderFns } from "./NewCabinetBanner.vue?vue&type=template&id=f259b534&scoped=true"
import script from "./NewCabinetBanner.vue?vue&type=script&lang=js"
export * from "./NewCabinetBanner.vue?vue&type=script&lang=js"
import style0 from "./NewCabinetBanner.vue?vue&type=style&index=0&id=f259b534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f259b534",
  null
  
)

export default component.exports